import {ReactElement, ReactNode} from 'react';
import {Loader, LoaderOptions} from '@googlemaps/js-api-loader';

export enum GoogleMapsLibraryStatus {
	LOADING = 'LOADING',
	FAILURE = 'FAILURE',
	SUCCESS = 'SUCCESS',
	RESETTING = 'RESETTING',
  }

/**
 * The `WrapperProps` interface extends the `LoaderOptions` interface from
 * [@googlemaps/js-api-loader](https://npmjs.com/package/@googlemaps/js-api-loader).
 * See the reference documentation for
 * [LoaderOptions](https://googlemaps.github.io/js-api-loader/interfaces/LoaderOptions.html)
 * for a complete list of all props that are available.
 */
export interface WrapperProps extends LoaderOptions {
	/**
	 * Children wrapped by the `<Wrapper>{elements}</Wrapper`.
	 */
	children?: ReactNode;
	/**
	 * Render prop used to switch on the status.
	 */
	render?: (status: GoogleMapsLibraryStatus) => ReactElement;
	/**
	 * Callback prop used to access `@googlemaps/js-api-loader` and `Status`.
	 *
	 * Note: The callback be executed multiple times in the lifecycle of the component.
	 */
	callback?: (status: GoogleMapsLibraryStatus, loader: Loader) => void;

	reload?: boolean;
}